export const LANDING_PAGES = {
  home: '/',
  features: '/features',
  about: '/about',
  techVendorsBenefits: '/tech-vendors-benefits',
  techVendorsFeatures: '/tech-vendors-features',
  techVendorsPricing: '/tech-vendors-pricing',
  techVendorsFAQ: '/tech-vendors-faq',
  blog: '/blog',
  itCustomerBlog: '/blog/it-customer',
  techVendorBlog: '/blog/tech-vendor',
  whitepapers: '/whitepapers',
  itCustomerWhitePapers: '/whitepapers/it-customer',
  techVendorWhitePapers: '/whitepapers/tech-vendor',
  press: '/press',
  privacyPolicy: '/privacy-policy',
  termsAndConditions: '/terms-and-conditions',
  disclaimer: '/disclaimer',
} as const
